import { useEffect, useState } from 'react';
import { Logger } from '../..//utils/Logger';
import { AudioHelper } from '../../HomeWorkouts/utils/AudioHelper';

export const useSetupAudioMode = () => {
  const [isSettingUpAudio, setIsSettingUpAudio] = useState(true);
  useEffect(() => {
    const setupAudioMode = async () => {
      await AudioHelper.setupAudioMode();
      setIsSettingUpAudio(false);
    };
    setupAudioMode().catch((e) => Logger.debug(e));
  });
  return [isSettingUpAudio];
};
